import { useNavigate } from 'react-router-dom';
import webcrux from '../assets/images/webcrux.png';
import './../styles/App.css';

const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-content">
          <h2>Welcome to Webcrux Technology Crafting High Performance Websites</h2>
          <p>At Webcrux Technology, we create lightning-fast, secure and easy-to-use websites designed to grow your business. Whether you need an eCommerce platform, a corporate site, or a custom web solution we turn your ideas into powerful digital experiences that deliver results.</p>
          <div className="cta-buttons">
            <button
              onClick={() => navigate('/quote')}
              className="btn primary no-underline"
            >
              Get Started
            </button>
            <button
              onClick={() => navigate('/services')}
              className="btn secondary no-underline"
            >
              Explore Our Services
            </button>
          </div>
        </div>
        <div className="hero-image">
          <img src={webcrux} alt="Hero Illustration" />
        </div>
      </div>
    </section>
  );
};

export default Hero;